module.exports = __webpack_public_path__ + "media/Icons/camera-pos/cam_3-057b58b3d7adb971ba0c033c415c9c0e.png";